import ChannelData from '@/services/builder/Channel'
import { CONSTRAINTS } from '@/services/helper/Constraints'

export const VIEWPORT_CHANNEL_NAMES = ['viewport', 'Recommendation']

export default class Viewport {
  constructor (options) {
    this.channelData = options.channelData
    this.adLayout = options.adLayout
    this.colCount = 4
    this.teaserCount = 0

    this.firstChannel = this.createChannelData(VIEWPORT_CHANNEL_NAMES[0])
    this.secondChannel = this.createChannelData(VIEWPORT_CHANNEL_NAMES[1])

    document.addEventListener('colCountChanged', (data) => {
      this.colCount = data.detail.colCount
      this.teaserCount = 0

      this.firstChannel = this.createChannelData(VIEWPORT_CHANNEL_NAMES[0])
      this.secondChannel = this.createChannelData(VIEWPORT_CHANNEL_NAMES[1])
    })
  }

  createChannelData (name) {
    if (!this.channelData) return

    const { navigation, meta, elements } = this.channelData
    const layout = CONSTRAINTS.channels[name].adLayout[this.adLayout][this.colCount].elements

    const channelData = {
      navigation: name === VIEWPORT_CHANNEL_NAMES[0] ? [] : navigation,
      meta:
        name === VIEWPORT_CHANNEL_NAMES[0]
          ? { ...meta, trackingName: VIEWPORT_CHANNEL_NAMES[0] }
          : {
            layoutColumns: '4col',
            layoutName: 'teasers',
            trackingName: 'threeList',
            name
          },
      elements: layout
        .map((element) => {
          switch (element.type) {
            case 'slider':
              return elements.filter((e) => e.type === element.type)?.[0]
            case 'teaser': {
              const teaser = elements?.filter((e) => e.type === element.type)?.slice(this.teaserCount, this.teaserCount + 1)[0]
              this.teaserCount++
              return teaser
            }
            case 'list': {
              const list = {
                type: element.type,
                elements: elements
                  ?.filter((e) => e.type === 'teaser')
                  ?.slice(this.teaserCount, this.teaserCount + element.elements.length)
                  .map((e) => {
                    return { ...e, authors: null, modificationDate: null, comments: null }
                  })
              }
              this.teaserCount += element.elements.length
              return list
            }
            case 'ad': {
              const componentPath = this.channelData.elements.find(e => e.tagid === element.tagid)?.trComponentPath || ''

              if (componentPath) {
                element.trComponentPath = componentPath
              }

              return element
            }
            default:
              return element
          }
        })
        .filter((e) => e)
    }

    return new ChannelData(channelData)
  }
}
